import PawModel from './PawModel';

class View extends PawModel {
  static apiType = 'views';

  static d3Compatible = false;

  mode?: string;

  title?: string;
}

export default View;
